(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/admin/dialog-adapter/assets/javascripts/message-box.js') >= 0) return;  svs.modules.push('/components/admin/dialog-adapter/assets/javascripts/message-box.js');
"use strict";


var dialog = svs.ui.dialog;
var Type = svs.components.dialogAdapter.helper.Type;
var _svs$components$dialo = svs.components.dialogWrapper.helper,
  button = _svs$components$dialo.button,
  cmsType = _svs$components$dialo.cmsType,
  icon = _svs$components$dialo.icon,
  newDialog = _svs$components$dialo.newDialog,
  text = _svs$components$dialo.text;

var convertTypeToCmsType = function convertTypeToCmsType(type) {
  switch (type) {
    case Type.INFO:
      return cmsType.INFO;
    case Type.ERROR:
      return cmsType.ERROR;
    default:
      return cmsType.INFO;
  }
};

var convertToMBButtons = function convertToMBButtons(buttons) {
  return buttons ? buttons.map(function (_ref) {
    var callback = _ref.callback,
      text = _ref.text;
    return button({
      callback: callback,
      title: text
    });
  }) : [];
};

var show = function show(_ref2) {
  var _dialog$api, _dialog$api$queue, _dialog$api$queue$are, _dialog$api$queue$are2;
  var buttons = _ref2.buttons,
    message = _ref2.message,
    title = _ref2.title,
    type = _ref2.type;
  if ((dialog === null || dialog === void 0 ? void 0 : (_dialog$api = dialog.api) === null || _dialog$api === void 0 ? void 0 : (_dialog$api$queue = _dialog$api.queue) === null || _dialog$api$queue === void 0 ? void 0 : (_dialog$api$queue$are = _dialog$api$queue.areas) === null || _dialog$api$queue$are === void 0 ? void 0 : (_dialog$api$queue$are2 = _dialog$api$queue$are.popup) === null || _dialog$api$queue$are2 === void 0 ? void 0 : _dialog$api$queue$are2.count()) > 0) {
    return;
  }
  var convertedType = convertTypeToCmsType(type);
  newDialog({
    area: dialog.area.POPUP,
    buttons: convertToMBButtons(buttons),
    icon: icon[convertedType],
    message: [text({
      text: message || ''
    })],
    title: title,
    type: "".concat(convertedType, " message-box-message")
  });
};
svs.components.MessageBox = {
  ButtonType: {},
  show: show,
  Type: Type
};

 })(window);